import React from 'react';

import { ArticleMode } from '../../../common/spdCore/validation/schemas';
import { useNavigation } from '../../../common/navigation';

import { ExamsSpecialistView } from './ExamsSpecialistView';

export const ExamsOphthalmologistView: React.FC = () => {
  const nav = useNavigation();

  return (
    <ExamsSpecialistView
      mode="ophthalmologist"
      articleMode={ArticleMode.Ophthalmologist}
      tabReadyTitle={'Badania okulistyczne do obsługi'}
      tabAllTitle={'Wszystkie badania okulistyczne'}
      onClick={nav.examTestsOphthalmologist}
    />
  );
};
